import React, { Component } from 'react'

import Meta         from './components/meta'
import Search       from './components/search'
import Attachments  from './components/attachments'
import Content      from './components/content'
import Modal        from './components/modal'

import './css/gallery.css'

export default class Gallery extends Component {

  state = {}

  componentDidMount() {
    this.load(this.props)
  }

  componentWillReceiveProps(props) {
    this.load(props)
  }

  load(props) {
    if (props.section.images) {
      this.images = props.section.images
    } else {
      this.images = props.section.items.slice()
      if (this.images[0] && this.images[0].name) {
        this.images.reverse()
      }
    }
    this.setState({images: this.images})
  }

  filter(query) {
    if (!query) {
      this.setState({images: this.images})
    } else if (!isNaN(query)) {
      this.setState({images: this.images.filter(image => image.name.startsWith(query + '.'))})
    } else {
      this.setState({images: this.images.filter(image => image.search.indexOf(query) !== -1)})
    }
  }

  render() {
    return !this.state.images ? '' : (
      <div className="gallery">
        <Meta data={this.props.data} item={this.props.section} />
        <h1 className="gallery-title">{this.props.section.title || this.props.section.name}</h1>
        {this.props.section.description && (
          <Content text={this.props.section.description} />
        )}
        <Search data={this.props.data} section={this.props.section} filter={this.filter.bind(this)} />
        <Attachments attachments={this.state.images} />
        {this.props.item && (
          <Modal data={this.props.data} attachment={this.props.item} />
        )}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/gallery.js